import { Box, Grid } from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../Layouts/Components/Header";
import Section from "./Section";
import {
  clearReportData,
  getCorzapReports,
  getCustomReports,
} from "./state/actions";
import useSnackBar from "../Hooks/useSnackBar";
import SecondaryButton from "../shared/SecondaryButton";
import NewReportModal from "./NewReportModal";
import { useNavigate } from "react-router-dom";

const Reports = () => {
  const { error, snackbar, success } = useSnackBar();

  const navigate = useNavigate();

  const { keycloak } = useKeycloak();
  const userId = keycloak.tokenParsed.preferred_username;
  const dispatch = useDispatch();
  const corzapReports = useSelector((state) => state.reporting.corzapReports);
  const customReports = useSelector((state) => state.reporting.customReports);
  const loadingReports = useSelector((state) => state.reporting.loadingReports);
  const loadingDefaultReports = useSelector(
    (state) => state.reporting.loadingDefaultReports
  );

  const [openNewReportModal, setOpenNewReportModal] = useState(false);

  const handleCloseNewReportModal = () => {
    setOpenNewReportModal(false);
  };

  const saveNewReport = (values) => {
    navigate(
      `/reports/custom/${values.reportName}?new=true&dateTimeFrom=${values.dateTimeFrom}&dateTimeTo=${values.dateTimeTo}`
    );
    setOpenNewReportModal(false);
  };

  useEffect(() => {
    dispatch(getCustomReports(userId, success, error));
    dispatch(getCorzapReports(success, error));
  }, [dispatch, userId, success, error]);

  useEffect(() => {
    return () => {
      dispatch(clearReportData());
    };
  }, [dispatch]);
  return (
    <div>
      {snackbar}
      <NewReportModal
        open={openNewReportModal}
        onClose={handleCloseNewReportModal}
        discardChanges={handleCloseNewReportModal}
        saveChanges={saveNewReport}
      />
      <Header headLine="Reports">
        <SecondaryButton
          sx={{
            backgroundColor: "var(--primary)",
            "&:hover": { backgroundColor: "var(--primary)" },
          }}
          onClick={() => {
            setOpenNewReportModal(true);
          }}
        >
          + New Report
        </SecondaryButton>
      </Header>
      <Box
        sx={{
          backgroundColor: "#F8FAFB",
          paddingLeft: "30px",
          paddingTop: "50px",
          paddingBottom: "30px",
        }}
      >
        <Grid container sx={{ marginBottom: "50px" }}>
          <Grid item xs={10}>
            <Section
              type="custom"
              sectionName={"Custom Reports"}
              sectionReports={customReports}
              limit={2}
              hasMore={customReports.length > 2}
              loading={loadingReports}
            />
          </Grid>
        </Grid>

        <Grid>
          <Grid item xs={10}>
            <Section
              type="corzap"
              sectionName={"Corzap Reports"}
              sectionReports={corzapReports}
              limit={4}
              hasMore={corzapReports.length > 4}
              isCorzapReports
              loading={loadingDefaultReports}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default Reports;
